import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import CalendarIcon from '@atlaskit/icon/core/calendar';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.date-picker-field.icon-label',
		defaultMessage: 'Date picker field icon',
		description:
			'Accessible label for the icon representing the date picker field in a Jira work item action card.',
	},
});

export function DatePickerFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<CalendarIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
